import {
    apiRegister
} from '../../common/api';

import {
    isNumber,
    isArray,
    map,
    forEach,
    fixNumber
} from '../../common/utils';
import { KLine } from '../../models/kline';
import { ERR_REQ_KID, ERR_REP_KLINES } from '../../common/const';

/*
协议Id 
891
项目 
模块 
方式 
https 
命令（路径） 
/award/reality/klines/
说明
实盘比赛获取题信息
*/

const klines = apiRegister('klines', {
    protoId: 891,
    path: '/award/reality/klines/',
    cache: 3600,  // 默认缓存小时
    checkQuery(Q) {
        if (!isNumber(Q.kid)) {
            return ERR_REQ_KID // 参数错误
        }
        return 0
    },
    checkResult(R) {
        const {
            klines
        } = R
        if (!isArray(klines)) {
            return ERR_REP_KLINES // 数据格式非法
        }
        return 0
    },
    formatResult(R) {
        const klines = map(R.klines, (raw) => KLine(raw))
        // 处理涨跌幅
        forEach(klines, (T, i) => {
            const Y = klines[i -1]
            T.index = i
            if(Y && Y.close > 0) {
                T.chgPrice = T.close - Y.close
                T.chgRate = fixNumber(T.chgPrice / Y.close, 4)
            } else {
                T.chgPrice = 0
                T.chgRate = 0
            }
        })
        return {
            klines
        }
    }
})

export const klinesLoad = klines.send
